/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 137
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GeoJsonProperties
 */
export interface GeoJsonProperties {
    [key: string]: string | any;
    /**
     * 
     * @type {string}
     * @memberof GeoJsonProperties
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof GeoJsonProperties
     */
    radius?: number;
    /**
     * 
     * @type {string}
     * @memberof GeoJsonProperties
     */
    parentId?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoJsonProperties
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoJsonProperties
     */
    owner?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoJsonProperties
     */
    description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GeoJsonProperties
     */
    acl?: Array<string>;
}

/**
 * Check if a given object implements the GeoJsonProperties interface.
 */
export function instanceOfGeoJsonProperties(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GeoJsonPropertiesFromJSON(json: any): GeoJsonProperties {
    return GeoJsonPropertiesFromJSONTyped(json, false);
}

export function GeoJsonPropertiesFromJSONTyped(json: any, ignoreDiscriminator: boolean): GeoJsonProperties {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
            ...json,
        'id': !exists(json, 'id') ? undefined : json['id'],
        'radius': !exists(json, 'radius') ? undefined : json['radius'],
        'parentId': !exists(json, 'parent_id') ? undefined : json['parent_id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'owner': !exists(json, 'owner') ? undefined : json['owner'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'acl': !exists(json, 'acl') ? undefined : json['acl'],
    };
}

export function GeoJsonPropertiesToJSON(value?: GeoJsonProperties | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
            ...value,
        'id': value.id,
        'radius': value.radius,
        'parent_id': value.parentId,
        'name': value.name,
        'owner': value.owner,
        'description': value.description,
        'acl': value.acl,
    };
}

